export default ({ POST, GET, UPLOAD }) => {
  return {
    // 获取评论
    GetComments: (...arg) => POST('/get_comments', ...arg),

    // 保存评论
    SaveComment: (...arg) => POST('/save_comment', ...arg),

    // 检测评论
    CheckComment: (...arg) => POST('/check_comment', ...arg),

    // 删除评论
    DelComment: (...arg) => POST('/del_comment', ...arg)
  }
}
